import React from "react";

import NavigationItem from "../Navigation/NavigationItems/NavigationItem/NavigationItem"
import footbaLogo from "../../assets/images/flaming-football.png";
import styles from "./Logo.module.css";
import { NavLink } from "react-router-dom";

const logo = props => (
  <div className={styles.Logo}>
    <NavLink to="/football">
      <img src={footbaLogo} alt="Football Fire" href="" />
    </NavLink>
  </div>
);

export default logo;
